import React from 'react'
import { language } from "../utils/translations";

console.log({language})

const styles = {
    root: {
        top: 40,
        [language === "ar" ? "right" : "left"]: 12,
        zIndex: 100,
        borderRadius: 8,
        display: "flex",
        background: "white",
        position: "absolute",
        flexDirection: "column",
        alignItems: "flex-start",
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 0.2em 0.8em"
    }
}

export const Menu = ({children}) => (
	<div
		style={styles.root}
	>
		{children}
	</div>
)



// WEBPACK FOOTER //
// ./src/components/Menu.js